import cx from "classnames";
import React, { useEffect, useRef, useState } from "react";
import s from "./WLToastError.module.scss";
import { IonButton, IonLabel } from "@ionic/react";
import { CancelCircle, Close } from "../../assets/icons";

export interface WLToastProps {
  isOpen: boolean;
  message: string;
  duration?: number;
  onDidDismiss: () => void;
}

const WLToastError: React.FC<WLToastProps> = ({
  isOpen,
  message,
  duration = 3000,
  onDidDismiss,
}) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [visible, setVisible] = useState(false);
  const [animateClass, setAnimateClass] = useState("enter");

  const handleCloseToast = () => {
    setAnimateClass("exit");
    setTimeout(() => {
      setVisible(false);
      onDidDismiss();
    }, 300);
  };

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setAnimateClass("enter");

      timerRef.current = setTimeout(() => {
        setAnimateClass("exit");
        setTimeout(() => {
          setVisible(false);
          onDidDismiss();
        }, 300);
      }, duration);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isOpen, duration, onDidDismiss]);

  if (!visible) return null;

  return (
    <div className={cx(s.toast, s[animateClass])}>
      <div className={s.iconContainer}>
        <CancelCircle className={s.icon} />
      </div>
      <div className={s.messageContainer}>
        <IonLabel className={cx(s.message, "win-sub regular gilroy dark")}>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </IonLabel>
        <IonButton
          fill="clear"
          className={s.closeIconBtn}
          onClick={handleCloseToast}
        >
          <div slot="icon-only">
            <Close className={s.closeIcon} />
          </div>
        </IonButton>
      </div>
    </div>
  );
};

export default WLToastError;
